import { ModuleSubtype, ModuleFeatures } from 'sigma-mappings';
import Chart from '@/domain/components/installation/supervision/sensors/Chart';
import General from '@/app/installation/supervision/sensors/general';
import Parameters from '@/app/installation/supervision/sensors/parameters';
import Configuration from '@/domain/components/installation/supervision/sensors/Configuration';
import ConfigurationDM1 from '@/app/installation/supervision/sensors/configurationDM1';
import ConfigurationDM2 from '@/app/installation/supervision/sensors/configurationDM2';
import RegulationSets from '@/app/installation/supervision/sensors/regulationSets';
import LatestManeuvers from '@/app/installation/supervision/sensors/latestManeuvers';
import ModuleInformation from '@/app/installation/supervision/sensors/moduleInformation';

/**
 * Definição de components para cada feature/aba dos sensores
 */
export default {
  [ModuleFeatures.GENERAL]: General,
  [ModuleFeatures.PARAMETERS]: Parameters,
  [ModuleFeatures.CONFIGURATION]: Configuration,
  [ModuleFeatures.CHART]: Chart,
  [ModuleFeatures.REGULATION_SETS]: RegulationSets,
  [ModuleFeatures.LATEST_MANEUVERS]: LatestManeuvers,
  [ModuleFeatures.MODULE_INFORMATION]: ModuleInformation,
};

/**
 * Subtipos de components para aba de configuração
 */
export const configurationTabs = {
  [ModuleSubtype.DM1]: ConfigurationDM1,
  [ModuleSubtype.DM2]: ConfigurationDM2,
};
